import { faProjectDiagram } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { memo } from 'react';
import { Handle, Position } from 'reactflow';
import styled from 'styled-components';

const NodeContainer = styled.div`
  padding: 10px;
  border-radius: 8px;
  background: #E6F1FF;
  border: 1px solid #2F80ED;
  width: 200px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
`;

const NodeHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
`;

const NodeIcon = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #2F80ED;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  margin-right: 8px;
`;

const NodeLabel = styled.div`
  font-weight: 500;
  font-size: 14px;
  color: #2F80ED;
  flex: 1;
`;

const NodeDescription = styled.div`
  font-size: 12px;
  color: #666;
  margin-bottom: 8px;
`;

const NodeDetails = styled.div`
  font-size: 11px;
  color: #777;
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const DetailItem = styled.div`
  display: flex;
`;

const DetailLabel = styled.span`
  font-weight: 500;
  margin-right: 5px;
`;

const DetailValue = styled.span`
  color: #555;
`;

const PlannerNode = ({ data }) => {
  const {
    name = 'Planner',
    description = 'Execute a planner against a query',
    data: innerData = {},
  } = data;

  const { planner_cd } = innerData;

  return (
    <NodeContainer>
      <Handle type="target" position={Position.Top} />

      <NodeHeader>
        <NodeIcon><FontAwesomeIcon icon={faProjectDiagram} /></NodeIcon>
        <NodeLabel>{name}</NodeLabel>
      </NodeHeader>

      <NodeDescription>{description}</NodeDescription>

      <NodeDetails>
        {planner_cd && (
          <DetailItem>
            <DetailLabel>Planner:</DetailLabel>
            <DetailValue>{planner_cd}</DetailValue>
          </DetailItem>
        )}
      </NodeDetails>

      <Handle type="source" position={Position.Bottom} />
    </NodeContainer>
  );
};

export default memo(PlannerNode);
